export var Method;
(function (Method) {
    Method["get"] = "get";
    Method["post"] = "post";
    Method["put"] = "put";
})(Method || (Method = {}));
//# sourceMappingURL=index.types.js.map